<template>
	<div >
		<el-button  v-if="item.authority===undefined?true:authority[item.authority]"  
		@click.stop="click(item)" v-for="(item,key) in param.buttons" :key="key" :size="size">{{item.txt}}</el-button>
	</div>
</template>

<script>
	//该页面为list页面不受权限控制的其他操作
	export default {
		data() {
			return {
				size: 'small',
			}
		},
		props: {
			param: {
				type: Object,
				default: {}
			},
			row: {
				type: Object,
				default: {}
			},
			authority:{
				type:Object,
				default:{}
			},
			childrenCom: ''
		},
		created() {
			console.log(this.buttons)
		},
		methods: {
			click(item) {
				item.fn(item, this.row)
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/sub/listCz.vue